<template>
    <div
        class="mailing_settings_container"
    >
        <h3 class="mailing_title">{{ title }}</h3>
        <div class="flex-col gap-10">
            <div v-if="type === 'sortedField' && !isTyresOnly" class="flex">
                <input
                    class="cursor_pointer"
                    type="checkbox"
                    id="sorted_brand"
                    @click="toggleChecked('sorted_brand')"
                    value="sorted_brand"
                    :checked="isChecked({id: 'sorted_brand'})"
                >
                <label for="sorted_brand" class="cursor_pointer">
                    brand:
                    <span>
                        Бренд
                    </span>
                </label>
            </div>
            <div v-else v-for="(field, index) in filterByData" :key="field.id" class="flex">
                <input
                    class="cursor_pointer"
                    type="checkbox"
                    :id="field.id"
                    @click="toggleChecked(field.id)"
                    :value="field.id"
                    :checked="isChecked(field)"
                    :disabled="isDisabled(field.id)"
                >
                <label :for="field.id" class="cursor_pointer">
                    {{ field.fieldsName }}:
                    <span>
                        {{ field.description }}
                    </span>
                </label>
                <button class="arrow_button" @click="moveUp(index)" v-if="index > 0">
                    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.46967 0.46967C5.76256 0.176777 6.23744 0.176777 6.53033 0.46967L11.3033 5.24264C11.5962 5.53553 11.5962 6.01041 11.3033 6.3033C11.0104 6.59619 10.5355 6.59619 10.2426 6.3033L6 2.06066L1.75736 6.3033C1.46447 6.59619 0.989593 6.59619 0.696699 6.3033C0.403806 6.01041 0.403806 5.53553 0.696699 5.24264L5.46967 0.46967ZM5.25 11L5.25 1H6.75L6.75 11H5.25Z" fill="#174A8B"/>
                    </svg>
                </button>
                <button class="arrow_button" @click="moveDown(index)" v-if="index < filterByData.length - 1">
                    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.46967 10.5303C5.76256 10.8232 6.23744 10.8232 6.53033 10.5303L11.3033 5.75736C11.5962 5.46447 11.5962 4.98959 11.3033 4.6967C11.0104 4.40381 10.5355 4.40381 10.2426 4.6967L6 8.93934L1.75736 4.6967C1.46447 4.40381 0.989593 4.40381 0.696699 4.6967C0.403806 4.98959 0.403806 5.46447 0.696699 5.75736L5.46967 10.5303ZM5.25 0L5.25 10H6.75L6.75 0L5.25 0Z" fill="#174A8B"/>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {useMailingStore} from "@/stores/MailingStore";
import { sortedByFieldsNoTyres } from '@/entities/Mailing/config/mailing.js';

export default {
    name: "SortableCheckboxes",
    props: ['title', 'type'],
    data: function () {
        return {
            isTyresOnly: true,
            sortedByFieldsNoTyres,
            warehouseIDs: ['field_stock_krd_main', 'field_stock_stavropol', 'field_stock_crimea', 'field_stock_voronezh'],
        }
    },
    computed: {
        filterByData() {
            return this.type === 'field' ? this.mailingStore.filteredFilterByFields : this.mailingStore.sortedByFields;
        },
    },
    setup() {
        const mailingStore = useMailingStore();
        return {
            mailingStore,
        }
    },
    created() {
        this.$watch(() => this.mailingStore.selectedProducts, () => {
            this.checkIsTyresOnlyCondition();
        });
        this.$watch(() => this.mailingStore.selectedStorageCities, () => {
            this.updateFilteredFilterByFields();
        });
        this.$watch(() => this.mailingStore.filterByFields, () => {
            this.updateFilteredFilterByFields();
        });
    },
    mounted() {
        this.checkIsTyresOnlyCondition();
        this.updateFilteredFilterByFields();
    },
    methods: {
        updateFilteredFilterByFields() {
            this.filteredFilterByFields = this.mailingStore.getFilteredFilterByFields;
        },
        checkIsTyresOnlyCondition() {
            this.isTyresOnly = this.mailingStore.selectedProducts.length === 1 && this.mailingStore.selectedProducts.includes('tyres');
        },
        toggleChecked(id) {
            const checkedItems = this.mailingStore.checked[this.type];
            const index = checkedItems.findIndex(item => item.id === id);

            if (index === -1) {
                checkedItems.push({ id: id });
            } else {
                checkedItems.splice(index, 1);
            }

            this.mailingStore.checked[this.type] = checkedItems;
        },
        moveUp(index) {
            if (index > 0) {
                const temp = this.filterByData[index];
                this.filterByData[index] = this.filterByData[index - 1];
                this.filterByData[index - 1] = temp;
                this.updateOrder();
                if (this.type === 'field') {
                    this.mailingStore.filterByFields = this.filterByData;
                } else {
                    this.mailingStore.sortedByFields = this.filterByData;
                }
                this.$forceUpdate();
            }
        },
        moveDown(index) {
            if (index < this.filterByData.length - 1) {
                const temp = this.filterByData[index];
                this.filterByData[index] = this.filterByData[index + 1];
                this.filterByData[index + 1] = temp;
                this.updateOrder();
                if (this.type === 'field') {
                    this.mailingStore.filterByFields = this.filterByData;
                } else {
                    this.mailingStore.sortedByFields = this.filterByData;
                }
                this.$forceUpdate();
            }
        },
        updateOrder() {
            this.filterByData.forEach((item, index) => {
                item.order = index + 1;
            });
        },
        isDisabled(id) {
            return this.warehouseIDs.includes(id);
        },
        isChecked(field) {
            if (field.city) {
                if (this.mailingStore.selectedStorageCities.includes(field.city)) {
                    !this.mailingStore.checked[this.type].some(item => item.id === field.id) ? this.mailingStore.checked[this.type].push(field) : null
                    return true;
                } else {
                    if (this.mailingStore.checked[this.type].some(item => item.id === field.id)) {
                        this.mailingStore.checked[this.type] = this.mailingStore.checked[this.type].filter(item => item.id !== field.id);
                    }

                    return false;
                }
            } else {
                return this.mailingStore
                    .checked[this.type].some(item => {
                    return item.id === field.id
                });
            }
        },
    },
}
</script>


<style scoped>
    .arrow_button {
        border: none;
        outline: none;
        background: none;
        cursor: pointer;
    }

    .arrow_button:hover > svg > path {
        fill: var(--color-green);
        transition: fill 0.3s ease-out;
    }

    .arrow_button > svg > path {
        fill: var(--color-blue);
    }
</style>
